import React from 'react';
import { colors, radii, shadows } from '../../theme/tokens';

// Displays the PAR logo. The shipped logo.png sits on a white square, so on the
// dark theme we present it inside a clean light chip by default (looks
// intentional). Pass `bare` once a transparent logo is supplied.
const BrandMark = ({ size = 56, withWordmark = false, bare = false, style }) => {
  const img = (
    <img
      src="/logo.png"
      alt="PAR"
      style={
        bare
          ? { width: size, height: size, objectFit: 'contain', display: 'block' }
          : {
              width: size,
              height: size,
              objectFit: 'contain',
              display: 'block',
              background: colors.white,
              borderRadius: radii.md,
              padding: Math.round(size * 0.1),
              boxShadow: shadows.sm
            }
      }
    />
  );

  if (!withWordmark) return <span style={{ display: 'inline-flex', ...style }}>{img}</span>;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 12, ...style }}>
      {img}
      <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.05 }}>
        <strong style={{ fontSize: size * 0.34, fontWeight: 800, color: colors.text, letterSpacing: 0.3 }}>
          PAR App
        </strong>
        <span style={{ fontSize: size * 0.2, color: colors.textMuted }}>Car Parts Manager</span>
      </span>
    </span>
  );
};

export default BrandMark;
